import React, { useState } from "react";
import "./VMRsuggestionStyles.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import refillEye from "../../../assests/refillEye.svg";
import search from "../../../assests/search.svg";
import crossEye from "../../../assests/crossEye.svg";
import emotions7 from "../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Menu, MenuItem } from "@mui/material";
import LoadingSpinner from "../../Loading/component";

const VMRsuggestionComponent = (props) => {
  const [isTableExtended, setTableExtended] = useState(false);
  const navigate = useNavigate();

  const handleEyeIconClick = () => {
    setTableExtended(!isTableExtended);
  };

  const handleClick = () => navigate("/");

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="vmr-suggestion-container">
          <div className="vmr-suggestion-sidebar">
            <Sidebar />
          </div>

          <div className="vmr-suggestion-content">
            <div className="vmr-suggestion-header">
              <h2 className="vmr-suggestion-title">
                <img
                  onClick={handleClick}
                  className="vmr-suggestion-back-icon"
                  src={leftArrow}
                  alt="Back"
                />{" "}
                Refill Suggestion
              </h2>
            </div>

            <div className="vmr-suggestion-controls">
              {/* Top Controls - Search and Warehouse Button */}
              <div className="vmr-suggestion-top-controls">
                <div className="vmr-suggestion-search">
                  <div className="vmr-suggestion-search-container">
                    <input
                      type="search"
                      placeholder="Search by VM Name/ VM ID"
                      value={props.searchValue}
                      onChange={props.handleSearchInputChange}
                      onKeyPress={props.handleKeyPress}
                      className="vmr-suggestion-search-input"
                    />
                    <button
                      className="vmr-suggestion-search-button"
                      onClick={props.handleSearchIconClick}
                    >
                      <img src={search} alt="Search" />
                    </button>
                  </div>
                </div>

                <div className="vmr-suggestion-warehouse-filter">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FilterListIcon />}
                    onClick={props.handleClick}
                    className="vmr-suggestion-warehouse-button"
                  >
                    {props.buttonLabel ||
                      (props.warehouseData.length > 0
                        ? props.warehouseData[0].warehouseName
                        : "Filter")}
                  </Button>

                  <Menu
                    className="vmr-suggestion-warehouse-menu"
                    anchorEl={props.anchorEl}
                    open={Boolean(props.anchorEl)}
                    onClose={props.handleClose}
                  >
                    {props.warehouseData.map((warehouse) => (
                      <MenuItem
                        key={warehouse.warehouseId}
                        onClick={() =>
                          props.handleOptionClick(
                            warehouse.warehouseId,
                            warehouse.warehouseName
                          )
                        }
                      >
                        {warehouse.warehouseName}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </div>

              {/* Priority Filters - Now just above the table */}
              <div className="vmr-suggestion-priority-filters-container">
                <div className="vmr-suggestion-priority-filters">
                  <label className="vmr-suggestion-priority-filter urgent-filter">
                    <input
                      type="checkbox"
                      value="URGENT"
                      checked={props.selectedCheckboxes.includes("URGENT")}
                      onChange={(e) => props.handleCheckboxChange(e, "URGENT")}
                    />
                    <span>Urgent</span>
                  </label>

                  <label className="vmr-suggestion-priority-filter high-filter">
                    <input
                      type="checkbox"
                      value="HIGH"
                      checked={props.selectedCheckboxes.includes("HIGH")}
                      onChange={(e) => props.handleCheckboxChange(e, "HIGH")}
                    />
                    <span>High</span>
                  </label>

                  <label className="vmr-suggestion-priority-filter medium-filter">
                    <input
                      type="checkbox"
                      value="MEDIUM"
                      checked={props.selectedCheckboxes.includes("MEDIUM")}
                      onChange={(e) => props.handleCheckboxChange(e, "MEDIUM")}
                    />
                    <span>Medium</span>
                  </label>

                  <label className="vmr-suggestion-priority-filter low-filter">
                    <input
                      type="checkbox"
                      value="LOW"
                      checked={props.selectedCheckboxes.includes("LOW")}
                      onChange={(e) => props.handleCheckboxChange(e, "LOW")}
                    />
                    <span>Low</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="vmr-suggestion-table-container">
              <div ref={props.tableContainerRef} className="vmr-suggestion-table-wrapper">
                <Table striped hover className="vmr-suggestion-table">
                  <thead>
                    <tr>
                      <th>VM ID</th>
                      <th>VM Name</th>
                      <th>Urgency Score</th>
                      <th>Urgency Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredData && props.filteredData.length > 0 ? (
                      props.filteredData.map((item) => (
                        <React.Fragment key={item.machineId}>
                          <tr className="vmr-suggestion-view">
                            <td>{item.machineId}</td>
                            <td>{item.machineName}</td>
                            <td>{item.urgencyScore}</td>
                            <td>
                              <span className={`vmr-suggestion-priority-tag ${item.priority?.toLowerCase()}-tag`}>
                                {item.priority}
                              </span>
                            </td>
                            <td className="vmr-suggestion-action-cell">
                              <img
                                src={
                                  props.selectedMachineId === item.machineId
                                    ? crossEye
                                    : refillEye
                                }
                                alt="Toggle details"
                                className="vmr-suggestion-eye-icon"
                                onClick={() =>
                                  props.handleEyeIconClick(item.machineId)
                                }
                              />
                            </td>
                          </tr>

                          {props.selectedMachineId === item.machineId && (
                            <tr className="vmr-suggestion-details-row">
                              <td colSpan="5" className="vmr-suggestion-details-cell">
                                <div className="vmr-suggestion-details-content">
                                  <div className="vmr-suggestion-detail-item">
                                    <span>Address:</span>
                                    <strong>{item.machineAddress}</strong>
                                  </div>
                                  <div className="vmr-suggestion-detail-item">
                                    <span>Last Refilled:</span>
                                    <strong>{item.lastRefilled}</strong>
                                  </div>
                                  <div className="vmr-suggestion-detail-item">
                                    <span>Weekday Average Sale:</span>
                                    <strong>{item.weeklyAverageSales}</strong>
                                  </div>
                                  <div className="vmr-suggestion-detail-item">
                                    <span>Non Empty Coil:</span>
                                    <strong>{item.nonEmptyRatio}</strong>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <div className="vmr-suggestion-empty-state">
                            <img src={emotions7} alt="No VMs found" />
                            <p>No VM Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VMRsuggestionComponent;